import React, {useEffect, useState} from 'react'
import { CasoGeneralComponent } from 'defcol-caso-general'
import EncargadoCompania from '.'
import { useLocation } from 'react-router-dom'
import { obtenerDatosLlaves } from '../../store/actions/encargado-compania-action'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container } from 'react-bootstrap'

const ReasignarAnularCerrar = () => {
    
    const {state}=useLocation()
    const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :26
    const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
    const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
    const dispatch = useDispatch()
    // const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    // const { cfg_form23} = data_encargado
    useEffect(()=>{
        dispatch(obtenerDatosLlaves({idCaso:idCasoLocation, idImplicado:idImplicado,idOrgCaso:idOrganizacionCaso}))
    },[dispatch])
  
    return (
        <div> 
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                        {`Atender Reasignación o Cierre de Caso ${idCasoLocation}`}
                    </Card.Header>
                    <Card.Body>
                            <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} /> 
                    </Card.Body>
                </Card>
            </Container>
            <EncargadoCompania/>
        </div>
    )
}

export default ReasignarAnularCerrar
